import type { EffectiveUser, PublicAppConfig, PublicMaintenance } from "@dropl/shared";
import { api } from "../api/index.js";
import { loadAppConfig } from "../config.js";

interface SessionState {
  config: PublicAppConfig;
  user: EffectiveUser | null;
}

let cached: SessionState | undefined;

export async function bootSession(): Promise<SessionState> {
  if (cached) return cached;
  const [config, me] = await Promise.all([
    loadAppConfig(),
    api<{ user: EffectiveUser | null }>("/api/auth/me").catch(() => ({ user: null })),
  ]);
  cached = { config, user: me.user };
  return cached;
}

export function currentSession(): SessionState {
  if (!cached) throw new Error("session not booted");
  return cached;
}

export function setUser(user: EffectiveUser | null): void {
  if (!cached) return;
  cached.user = user;
}

export function setMaintenance(m: PublicMaintenance): void {
  if (!cached) return;
  cached.config = { ...cached.config, maintenance: m };
}
